import '../../App.css'


export default function CodebaseLibs() {
    return (
      <h2>Breakdown of the existing libraries</h2>
    
    );
  }